<jqxLoader #loader [imagePosition]="'top'" [width]="60" [height]="60" [text]="'Espere...'">
</jqxLoader>

<div class="panel panel-primary my-1 mx-auto rounded-3 shadow-lg" style="height: 99%;">
    <div class="panel-heading clearfix">
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-5">
                <div class="panel-title pull-left">
                    <span style="font-size: x-large;">Opciones de menú y permisos por aplicación</span>
                </div>
            </div>
            <div class="col-md-3"></div>
        </div>
    </div>

    <!-- FILTROS -->
    <div class="m-2 p-2 rounded-3 borderFilter" style="height: 50px;">
    </div>

    <div class="row" style="margin-top: 20px;">
        <div class="col-2" style="float: left;  margin-left: 20px;">
            <div style="clear: both;">
                <h5 style="float: left; ">Aplicaciones</h5>
            </div>
            <div style="clear: both;">
                <jqxGrid #gridApps [theme]="environment.tema" [width]="'100%'" [height]="480" [source]="dataAdapterApps"
                    [columnsresize]="true" [localization]="langGrid" [filterable]="true" [showfilterrow]="true"
                    [columns]="columnsApps" [showrowlines]="false" [showcolumnlines]="true" [pageable]="false"
                    [sortable]="true" [altrows]="true" [showstatusbar]="true" [statusbarheight]="20"
                    [showaggregates]="true" [rowsheight]="20" [columnsheight]="20" [enabletooltips]="true"
                    [editable]="false" (onRowclick)="onAppSelect($event)">
                </jqxGrid>
            </div>
        </div>

        <div *ngIf="idAppSelec > 0" class="col-3" style="float: left; width: 20%;">
            <div style="clear: both;">
                <h5>Roles</h5>
                <jqxDropDownList #cbRoles [width]="'100%'" [height]="25" [selectedIndex]="0"
                    (onSelect)="onChangeRol($event)">
                </jqxDropDownList>
            </div>
            <div *ngIf="rolSelect.Nombre">
                <div style="clear: both; margin-top: 4px; overflow: hidden;">
                    <div style="float: left;">
                        <jqxCheckBox #checkAll style='margin-left: 24px; float: left;' [width]='70' [height]='25'
                            [checked]='false' (onChange)="onCheckAll($event)">
                            <span>Todo</span>
                        </jqxCheckBox>
                    </div>
                    <!-- <h6 style="float: left;">Menú de {{rolSelect.Nombre}}</h6> -->
                </div>
                <div style="clear: both;">
                    <jqxTree #treeMenu [theme]="environment.tema" [width]="'100%'" [height]="424"
                        [hasThreeStates]="false" [source]="recordsRoles" [checkboxes]="true" [allowDrag]="true"
                        [allowDrop]="true" [hasThreeStates]="false" (onSelect)="onMenuSelect($event)"
                        (onCheckChange)="onMenuChange($event)">
                    </jqxTree>
                </div>
                <div style="clear: both;">
                    <jqxButton style="margin-top: 10px; float: left; margin-right: 0px;" [width]='100' [height]='26'
                        [theme]="theme" [imgSrc]='"/assets/images/save.png"' (onClick)="onSave()">
                        Guardar
                    </jqxButton>
                </div>
            </div>
        </div>

        <div *ngIf="opcionSelectId>0" class="col-4" style="float: left;">
            <div style="float: left; width: 160%;">
                <h5 style="float: left;">Permisos generales</h5>
                <div style="clear: both;">
                    <jqxGrid #gridPermisosGenerales [theme]="environment.tema" [width]="'100%'" [height]="200"
                        [source]="dataAdapterPermisos" [columnsresize]="true" [selectionmode]="'checkbox'"
                        [localization]="langGrid" [filterable]="true" [showfilterrow]="false"
                        [columns]="columnsPermisos" [showrowlines]="false" [showcolumnlines]="true" [pageable]="false"
                        [sortable]="true" [altrows]="true" [showstatusbar]="true" [statusbarheight]="20"
                        [showaggregates]="true" [rowsheight]="20" [columnsheight]="20" [enabletooltips]="true"
                        [editable]="false" (onRowselect)="onPermisoSelect($event, true, true)"
                        (onRowunselect)="onPermisoSelect($event, false, true)">
                    </jqxGrid>
                </div>
            </div>
            <div *ngIf="apartados && apartados.length>0" style="width: 100%; clear: both;">
                <h5 style="float: left; margin-top: 16px; ">Apartados</h5>
                <div style="clear: both;">
                    <jqxGrid #gridApartados style="float: left;" [theme]="environment.tema" [width]="'100%'"
                        [height]="230" [source]="dataAdapterApartados" [columnsresize]="true" [localization]="langGrid"
                        [filterable]="true" [showfilterrow]="false" [columns]="columnsApartados" [showrowlines]="false"
                        [showcolumnlines]="true" [pageable]="false" [sortable]="true" [altrows]="true"
                        [showstatusbar]="true" [statusbarheight]="20" [showaggregates]="true" [rowsheight]="20"
                        [columnsheight]="20" [enabletooltips]="true" [editable]="false"
                        (onRowclick)="onApartadoSelect($event)">
                    </jqxGrid>
                </div>
            </div>
        </div>

        <div *ngIf="opcionSelectId>0 && apartadoSelec.Nombre" class="col-3" style="float: left;">
            <h5 style="float: left; margin-top: 249px;">Permisos por apartado</h5>
            <div style="clear: both;">
                <jqxGrid #gridPermisos [theme]="environment.tema" [width]="'100%'" [height]="230"
                    [source]="dataAdapterPermisos" [columnsresize]="true" [selectionmode]="'checkbox'"
                    [localization]="langGrid" [filterable]="true" [showfilterrow]="false" [columns]="columnsPermisos"
                    [showrowlines]="false" [showcolumnlines]="true" [pageable]="false" [sortable]="true"
                    [altrows]="true" [showstatusbar]="true" [statusbarheight]="20" [showaggregates]="true"
                    [rowsheight]="20" [columnsheight]="20" [enabletooltips]="true" [editable]="false"
                    (onRowselect)="onPermisoSelect($event, true, false)"
                    (onRowunselect)="onPermisoSelect($event, false, false)">
                </jqxGrid>
            </div>
        </div>

    </div>
</div>